import 'slick-carousel/slick/slick'

export default class TestimonialsBannerSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-testimonials-b-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                prevArrow: $('.js-testimonials-b-previous'),
                nextArrow: $('.js-testimonials-b-next'),
                appendDots: $('.js-testimonials-b-dots'),
            });

            const updateSlideIndex = () => {
                const slideIndex = this.settings.$slider.slick('slickCurrentSlide');
                const buttons = $('.js-testimonials-b-slider .slick-slide.slick-current.slick-active').find('.slick-dots li button');
                const activeButton = buttons[slideIndex];

                activeButton.style.backgroundColor = '#FFF';
            }

            updateSlideIndex();
            this.settings.$slider.on('afterChange', updateSlideIndex);
        }

    }

};

new TestimonialsBannerSlider();